<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import storage from '@/plugins/storage';
export default {
  name: 'App',
  mounted () {
    let uuid = storage.getItem('uuid');
    if (!uuid) {
      uuid = uuidv4();
      storage.setItem('uuid', uuid);
    }
  }
};
</script>
<style lang="scss">
  @import "@/assets/styles/element-variables.scss";
  @import "@/assets/styles/saas.scss";
  // #app{
  //   @include background_color($light_background_color);
  // }
  .ivu-menu {
    z-index: 8 !important;
  }
  .has-menu {
    padding-top: $menu-height;
  }

  // v2
  .v2-has-head {
    padding-top: $head-height-v2;
    background: $bg-color-v2;
  }
  .v2-has-both {
    padding-top: $head-height-v2 + $menu-height-v2;
    background: $bg-color-v2;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue